import BaseService from '../BaseService';

class ShopReportService extends BaseService {
  dashboard = async (filter) => {
    const data = await this._api.post('/report/shop/dashboard', filter);
    return data;
  };
}

export default ShopReportService;
